import React from 'react';
import { Layout } from 'antd';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Channel from './pages/Channel';
import Join from './pages/Join';
import './App.css';

const { Header, Content, Footer } = Layout;

function App() {
  return (
    <Router>
      <Layout className="layout">
        <Header>
          <div className="header-content">
            <img 
              src="https://gustaffo.com/wp-content/uploads/2022/11/Group-3-3-281x70.png" 
              alt="Gustaffo Logo" 
              className="header-logo"
            />
          </div>
        </Header>
        <Content>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/channel/:channelId" element={<Channel />} />
            <Route path="/join/:channelId" element={<Join />} />
          </Routes>
        </Content>
        <Footer>
          <div className="footer-content">
            <div className="footer-links">
              <a href="https://gustaffo.com/about">Imprint</a>
              <a href="https://gustaffo.com/general-terms-conditions">General Terms & Conditions</a>
              <a href="https://gustaffo.com/privacy-policy">Privacy Policy</a>
              <a href="https://status.gustaffo.com">Status Page</a>
              <a href="https://gustaffo.atlassian.net/servicedesk/customer/portal/3">Customer Support</a>
              <a href="https://gustaffo.com/about/security-information">Security Information</a>
            </div>
          </div>
        </Footer>
      </Layout>
    </Router>
  );
}

export default App; 